module.exports = __webpack_public_path__ + "static/media-routing-number-5565d9df125eab229f46813aa1ce0638.webp";